import type { CookieCategoryInfo, ConsentPreferences } from '../CookieConsent.types';

export const COOKIE_CONSENT_KEY = 'bi_cookie_consent';
export const COOKIE_CONSENT_VERSION = '1';
export const COOKIE_MAX_AGE_DAYS = 365;

export const COOKIE_CATEGORIES: CookieCategoryInfo[] = [
  {
    id: 'necessary',
    label: 'Strictly Necessary',
    description: 'Essential for the website to function. These cookies cannot be disabled.',
    required: true,
  },
  {
    id: 'analytics',
    label: 'Analytics',
    description:
      'Help us understand how visitors interact with our website by collecting anonymous usage data.',
    required: false,
  },
  {
    id: 'marketing',
    label: 'Marketing',
    description: 'Used to track visitors across websites to display relevant advertisements.',
    required: false,
  },
];

export const DEFAULT_PREFERENCES: ConsentPreferences = {
  necessary: true,
  analytics: true,
  marketing: true,
};

export const ALL_ACCEPTED: ConsentPreferences = {
  necessary: true,
  analytics: true,
  marketing: true,
};

export const ALL_REJECTED: ConsentPreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
};
